<template>
  <div
    class="modal fade"
    id="affiliationAnnouncementModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="affiliationAnnouncementModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content border-0 shadow-lg ann-modal">
        <div class="ann-header">
          <div class="ann-header-main">
            <div class="ann-icon">
              <i class="material-icons">handshake</i>
            </div>
            <div>
              <p class="ann-eyebrow mb-1">Nova funcionalidade</p>
              <h4 class="text-white mb-0 font-weight-bolder" id="affiliationAnnouncementModalLabel">
                Afiliados na sua campanha
              </h4>
            </div>
          </div>
          <button type="button" class="ann-close" aria-label="Fechar" @click="closeModal">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="modal-body ann-body">
          <p class="ann-lead mb-3">
            Multiplique o alcance da rifa: convide sua equipe, cada um recebe um link exclusivo e você controla comissão e pagamentos.
          </p>

          <div class="ann-notice mb-4">
            <i class="material-icons">info</i>
            <div>
              <strong>Fase de testes</strong>
              <p class="mb-0">
                Podem ocorrer ajustes ou instabilidades. Se algo falhar, fale com o suporte.
              </p>
            </div>
          </div>

          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <div class="ann-feature">
                <div class="ann-feature-icon">
                  <i class="material-icons">group_add</i>
                </div>
                <div>
                  <h6 class="mb-1 font-weight-bold">Convide sua equipe</h6>
                  <p class="mb-0 text-sm">
                    Gere o link de convite e envie só para quem quiser. Cada pessoa ganha um link de divulgação.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ann-feature">
                <div class="ann-feature-icon">
                  <i class="material-icons">insights</i>
                </div>
                <div>
                  <h6 class="mb-1 font-weight-bold">Controle total</h6>
                  <p class="mb-0 text-sm">
                    Defina a comissão, veja ranking, cliques e vendas, e marque o que já pagou fora da plataforma.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 justify-content-end">
            <button type="button" class="btn btn-outline-secondary mb-0" @click="closeModal">
              Depois
            </button>
            <button type="button" class="btn bg-gradient-primary mb-0" @click="closeModal">
              Configurar meus afiliados
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "AffiliationAnnouncementModal",
  emits: ["close"],
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal, {
      backdrop: "static",
      keyboard: false,
    });
    this.modalInstance.show();
  },
  methods: {
    async closeModal() {
      try {
        const UsersHttp = (await import("@/http/UsersHttp")).default;
        await UsersHttp.markAffiliationModalSeen();

        const user = this.$store.getters.user;
        user.seen_affiliation_modal = true;
        this.$store.commit("setUser", user);
        localStorage.setItem("campaign_affiliation_launch_seen", "true");
      } catch (err) {
        console.error("Erro ao marcar modal de afiliação como visto:", err);
      }

      this.modalInstance.hide();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.ann-modal {
  --ann-purple: #661cb0;
  --ann-purple-soft: #f8f5fc;
  --ann-ink: #344767;
  --ann-muted: #67748e;
  --ann-line: #e9ecef;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.ann-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.35rem;
  background: linear-gradient(135deg, #661cb0 0%, #8b3dd4 55%, #a855f7 100%);
}

.ann-header-main {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
}

.ann-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  box-shadow: 0 8px 18px rgba(102, 28, 176, 0.25);
}

.ann-icon .material-icons {
  font-size: 26px;
}

.ann-eyebrow {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ann-close {
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.ann-close .material-icons {
  font-size: 18px;
}

.ann-body {
  padding: 1.35rem 1.4rem 1.45rem;
  color: var(--ann-ink);
}

.ann-lead {
  color: var(--ann-muted);
  font-size: 0.95rem;
  line-height: 1.5;
}

.ann-notice {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  padding: 0.9rem 1rem;
  border-radius: 12px;
  background: var(--ann-purple-soft);
  border: 1px solid rgba(102, 28, 176, 0.12);
  color: var(--ann-ink);
}

.ann-notice .material-icons {
  color: var(--ann-purple);
  font-size: 20px;
  margin-top: 1px;
}

.ann-notice strong {
  display: block;
  font-size: 0.82rem;
  margin-bottom: 0.15rem;
  color: var(--ann-purple);
}

.ann-notice p {
  font-size: 0.78rem;
  color: var(--ann-muted);
  line-height: 1.45;
}

.ann-feature {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  height: 100%;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid var(--ann-line);
  background: linear-gradient(135deg, #ffffff 0%, var(--ann-purple-soft) 100%);
}

.ann-feature-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: #fff;
  background: linear-gradient(145deg, var(--ann-purple), #8b3dd4);
  box-shadow: 0 8px 16px rgba(102, 28, 176, 0.2);
}

.ann-feature-icon .material-icons {
  font-size: 22px;
}

.ann-feature h6 {
  color: var(--ann-ink);
  font-size: 0.9rem;
}

.ann-feature p {
  color: var(--ann-muted);
  line-height: 1.45;
}

@media (max-width: 575.98px) {
  .ann-header,
  .ann-body {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
